/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import PurchaseMissionDto from './PurchaseMissionDto';

/**
 * The SearchingQueryResponseModelPurchaseMissionDto model module.
 * @module model/SearchingQueryResponseModelPurchaseMissionDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelPurchaseMissionDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelPurchaseMissionDto</code>.
     * @alias module:model/SearchingQueryResponseModelPurchaseMissionDto
     */
    constructor() { 
        
        SearchingQueryResponseModelPurchaseMissionDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelPurchaseMissionDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelPurchaseMissionDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelPurchaseMissionDto} The populated <code>SearchingQueryResponseModelPurchaseMissionDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelPurchaseMissionDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [PurchaseMissionDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelPurchaseMissionDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/PurchaseMissionDto>} result
 */
SearchingQueryResponseModelPurchaseMissionDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelPurchaseMissionDto;

